module.exports = __webpack_public_path__ + "img/workContents03-04_play.194ee4f5.gif";